import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "../lib/brand";

export default function StickyBottomBar() {
  return (
    <div
      className="fixed bottom-3 sm:bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-1.5 bg-white border border-zinc-200 shadow-xl rounded-full px-1.5 py-1.5 max-w-[calc(100vw-1.5rem)]"
      data-testid="sticky-bottom-bar"
    >
      <Link
        to="/clarity-call"
        className="flex items-center gap-1.5 sm:gap-2 bg-[#1D4ED8] text-white px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium hover:bg-[#1E40AF] transition-colors whitespace-nowrap"
        data-testid="sticky-book-call"
      >
        <Phone className="h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0" />
        <span className="hidden xs:inline sm:inline">Book Clarity Call</span>
        <span className="xs:hidden sm:hidden">Book Call</span>
      </Link>
      <a
        href={BRAND.contact.whatsapp}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-1.5 sm:gap-2 text-zinc-800 hover:text-[#1D4ED8] px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium whitespace-nowrap"
        data-testid="sticky-whatsapp"
      >
        <MessageCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0" />
        <span>WhatsApp</span>
      </a>
    </div>
  );
}
